import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const { attendees,attendeesByids, attendee,attendeeExist,attendeeFormChange,confirmationOpened} = api




/**
 * 查找参与人列表
 */
export async function findAttendees(params) {
    return request({url: attendees, method: 'get', data: params,})
}
export async function findAttendee(params) {
    return request({url: attendee, method: 'get', data: params,})
}
export async function findAttendeesByids(params) {
    return request({url: attendeesByids, method: 'get', data: params,})
}

export async function existAttendee(params) {
    return request({url: attendeeExist, method: 'get', data: params})
}
export async function updateAttendeeForm(attendeeId, params) {
    return request({url: `${attendeeFormChange}?attendeeId=${attendeeId}`, method: 'post', data: params,})
}
export async function signConfirmationOpened(params) {
    return request({url: confirmationOpened, method: 'post', data: params})
}





// WEBPACK FOOTER //
// ./src/services/attendee.js